import { render, staticRenderFns } from "./ThreadListItemSkeleton.vue?vue&type=template&id=6269d97c&scoped=true"
import script from "./ThreadListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./ThreadListItemSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ThreadListItemSkeleton.vue?vue&type=style&index=0&id=6269d97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6269d97c",
  null
  
)

export default component.exports